const gravar_retrato_matricula_para_o_censo = [
  {
    path: "/gravar-retrato-matricula-para-o-censo",
    name: "gravar_retrato_matricula_para_o_censo",
    meta: {
      breadCrumb: "Censo Escolar - Retrato para o Censo",
      allowedPermissions: ["retrato_matricula_gravar"],
    },
    component: () =>
      import(
        "@/views/GravarRetratoMatriculasParaCenso/GravarRetratoMatriculasParaCenso.vue"
      ),
  },
];

export { gravar_retrato_matricula_para_o_censo };
